export class AccountDomain {
  constructor(
    public readonly accountNumber: string,
    public readonly description: string
  ) {}

  static fromPrimitives(obj: { accountNumber: string; description: string }): AccountDomain {
    return new AccountDomain(obj.accountNumber, obj.description);
  }
}
